import React, { createContext, useEffect, useState, } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../utils/axios-instance.js";
import PageLoader from "../components/page-loader.jsx";
import { toast } from "sonner";
import ParseErrors from "../utils/parse-errors.js";

const unProtectedPages = ["/login", "/", "/forgotpassword", "/testImage"];  

export const AuthContext = createContext(undefined);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  let pathname = location.pathname;

  const UpdateLoginData = (loginData) => {
    setUser({ isLoggedIn: true, data: loginData });
  };

  // ---------------------------- [ IF NO SESSIONS ] ----------------------------
  const HandleNoSession = (errorMessage) => {
    if (!unProtectedPages.includes(pathname) && !loading) {
      navigate("/login");
      toast.error(errorMessage || "Session Expired");
    }
    setUser(undefined);
    setLoading(false);
  };

  // ------------------------- [ UPDATE USER SESSION ] ------------------------
  const UpdateUserSession = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/auth/login");
      if (res.data?.isLoggedIn === false) {
        HandleNoSession(res.data.message);
      } else {
        setUser(res.data);
        setLoading(false);
      }
    } catch (error) {
      if (
        error?.response?.data?.isLoggedIn === false ||
        !error?.response?.status
      ) {
        HandleNoSession(error?.response?.data?.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    UpdateUserSession();
  }, [pathname]);

  // ----------------------------- [ USER LOGOUT ] ----------------------------------
  const HandleUserLogOut = async () => {
    setLoading(true);
    try {
      await axiosInstance.get("/auth/logout");
      toast.success("Logged out successfully");
      navigate("/login");
      setUser(undefined);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(ParseErrors(error));
    }
  };

  // --------------------- [ REDIRECT BASED ON AUTH STATUS ] -------------------------
  useEffect(() => {
    if (pathname === "/") {
      return;
    } else if (
      !loading &&
      user?.data?.user?.id &&
      unProtectedPages?.includes(pathname)
    ) {
      navigate("/");
    }
  }, [loading, user, navigate, pathname]);

  //   -------------------------------------- LOADER -----------------------------------
  if (loading && !user?.data.user.id) {
    return <PageLoader />;
  }

  return (
    <AuthContext.Provider
      value={{
        UpdateLoginData,
        HandleUserLogOut,
        isLoading: loading,
        user: user?.data?.user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
